import React from 'react';

const RecordingPlayerModal = ({ show, recording, onClose }) => {
  if (!show || !recording) return null;

  return (
    <div
      className="modal d-block"
      tabIndex="-1"
      style={{ background: 'rgba(0,0,0,0.5)' }}
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{recording.title}</h5>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>
          <div className="modal-body">
            {recording.video_url ? (
              <video
                className="recording-video"
                src={recording.video_url}
                controls
              />
            ) : (
              <div className="alert alert-info">
                This recording has no stored media URL on the server.
                In a production setup, upload the recorded blob to PHP and save the file path.
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecordingPlayerModal;
